import EffortsTableWithFilters from 'pages/efforts/EffortsTable';
import React from 'react';

interface Props {
    matterId?: string;
}

const EffortView: React.FC<Props> = ({ matterId }) => {
    if (!matterId) {
        return null;
    }

    return (
        <div className="flex h-full flex-col gap-4">
            <EffortsTableWithFilters
                passiveFilter={`matters.matter.id==(${matterId})`}
                matterId={matterId}
                disabledFilterIds={['effortForPartyFilter']}
            />
        </div>
    );
};

export default EffortView;
